interface LeaveMeetingOptions {
  meetingId: string;
  meetingManager: any; // Replace with proper type from SDK
  setMeetingMode: (mode: any) => void;
}

export const leaveMeeting = async ({
  meetingId,
  meetingManager,
  setMeetingMode,
}: LeaveMeetingOptions): Promise<void> => {
  try {
    // Leave the meeting in the SDK
    await meetingManager.leave();

    // Reset meeting mode
    setMeetingMode(null);
  } catch (error) {
    console.error("Error leaving meeting:", error);
    throw error;
  }
}; 